export const GET_ALL_LEADS = 'GET_ALL_LEADS'
export const GET_LEAD_DETAILS = 'GET_LEAD_DETAILS'
export const GET_LEAD_FILTERS = 'GET_LEAD_FILTERS'
export const UPDATE_LEAD_STATUS='UPDATE_LEAD_STATUS'
export const UPDATE_LEAD_ACCOUNT = 'UPDATE_LEAD_ACCOUNT'
export const CREATE_NEW_LEAD='CREATE_NEW_LEAD'
export const FETCH_CUSTOMER_DETAILS='FETCH_CUSTOMER_DETAILS'
